import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import Close from './Close';
import { StylesModalVariables } from './Modal';
import { jsx as ___EmotionJSX } from "@emotion/react";

const ModalHeader = _ref => {
  let {
    centered,
    className,
    setIsOpen,
    title
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["centered", "className", "setIsOpen", "title"]);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    css: [{
      display: 'grid',
      padding: StylesModalVariables(theme).padding
    }, process.env.NODE_ENV === "production" ? "" : ";label:ModalHeader;"],
    className: clsx('CK__ModalHeader', className)
  }, rest), ___EmotionJSX("div", {
    css: /*#__PURE__*/_css(_objectSpread(_objectSpread({}, theme.text.xlarge), {}, {
      fontWeight: theme.fontWeight.bold,
      textAlign: 'center'
    }), process.env.NODE_ENV === "production" ? "" : ";label:ModalHeader;")
  }, title), ___EmotionJSX(Close, {
    onClick: () => setIsOpen(false),
    css: /*#__PURE__*/_css({
      position: 'absolute',
      top: theme.space.base,
      right: theme.space.base,
      zIndex: 1
    }, process.env.NODE_ENV === "production" ? "" : ";label:ModalHeader;")
  }));
};

export default ModalHeader;